// import { Rollbar } from './services'
// Rollbar.debug('Application starting');

import * as Sentry from '@sentry/browser';
import jsmediatags from 'jsmediatags';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import StartupBoundary from './components/common/errorBoundary/startupBoundary';
import firebaseInit from './services/firebase';
import { beforeBreadcrumb, beforeSend } from './services/sentryScrub';
import './styles/index.scss';

if (process.env.NODE_ENV === 'development') {
  (global as any)['jsmediatags'] = jsmediatags;
}

if (process.env.NODE_ENV === 'production') {
  // Error reporting must never be able to take the app down. Ad blockers
  // routinely refuse the ingest endpoint (uBlock Origin does, out of the
  // box), and the SDK copes with that on its own - but the app has no
  // business depending on the outcome either way, so the one call that
  // could conceivably throw is fenced off like firebaseInit already is.
  try {
    Sentry.init({
      dsn: "https://b5a1a3087a64be868a7ca9e87c59b099@o349991.ingest.us.sentry.io/2303514",
      // Both hooks, not just beforeSend: the Drive file ids were mostly in
      // breadcrumbs, which record every fetch url automatically.
      beforeBreadcrumb,
      beforeSend,
    });
  }
  catch (err) {
    console.error('Sentry initialisation failed, continuing without it', err);
  }

  firebaseInit();
}

ReactDOM.render(
  <StartupBoundary>
    <Router>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>
  </StartupBoundary>,
  document.getElementById('root')
);
